/**
 * Shared constants for class cover images (form preview, list thumbnails).
 * Used when the chosen/uploaded image is missing or fails to load.
 */

/** Data URL for a neutral "Image unavailable" placeholder (SVG). */
export const CLASS_IMAGE_PLACEHOLDER =
  `data:image/svg+xml,${ 
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="250" viewBox="0 0 400 250"><rect width="400" height="250" fill="#e5e7eb"/><text x="200" y="125" text-anchor="middle" fill="#9ca3af" font-family="system-ui,sans-serif" font-size="14">Image unavailable</text></svg>'
  )}`;
